import React from 'react';
import { AtlassianAccountOnboardingBanner } from 'app/src/components/AtlassianAccountOnboardingBanner';

export const Banners = () => <AtlassianAccountOnboardingBanner />;
